import { BaseSyntheticEvent, MouseEvent, useEffect, useState } from "react";
import styles from "./UserInfoInput.module.css";
import Button from "../common/Button";
import Icon from "../common/Icon";

interface UserInfoInputProps {
    name: string;
    label?: string;
    type?: string;
    placeholder?: string;
    button?: string;
    initIcon?: string;
    cautionMsg?: string;
    value?: string;
    onChange?: (e: BaseSyntheticEvent) => void;
    onButtonClick?: (e: MouseEvent<HTMLElement>) => void;
    onIconClick?: (e: MouseEvent<HTMLElement>) => void;
}

/**
 * @author bakim
 * @date 2024-09-11 10:56:38
 * @remark 사용자 정보
 * @param {string} name 인풋 이름(정보)
 * @param {string} label? 라벨 정보
 * @param {string} type? 인풋 타입(password...)
 * @param {string} placeholder? placeholder
 * @param {string} button? 버튼 명
 * @param {string} initIcon? 인풋창 우측 아이콘(타입)
 * @param {string} cautionMsg? 인풋박스 아래 경고 메세지
 * @param {(e: BaseSyntheticEvent) => void} onChange? 인풋 값 변경 시 콜백 함수
 * @param {(e: MouseEvent<HTMLElement>) => void} onButtonClick? 버튼 클릭 시 콜백 함수
 * @param {(e: MouseEvent<HTMLElement>) => void} onIconClick? 인풋창 내부 아이콘 클릭 시 콜백 함수
 * @returns <UserInfoInput>
 */
const UserInfoInput = (props: UserInfoInputProps) => {
    const [iconType, setIconType] = useState(props.initIcon);
    const [inputType, setInputType] = useState(props.type);
    const [userName, setUserName] = useState(props.value)

    useEffect(() => {
        props.type === "password" && setIconType("view_off");
        !inputType && setInputType("input");
    }, []);

    const handleInputChange = (e: BaseSyntheticEvent) => {
        props.onChange && props.onChange(e);
        setUserName(e.target.value)
    };
    const handleButtonClick = (e: MouseEvent<HTMLElement>) => {
        props.onButtonClick && props.onButtonClick(e);
    };

    const handleIconClick = (e: MouseEvent<HTMLElement>) => {
        props.onIconClick && props.onIconClick(e);

        if (props.type && props.type === "password") {
            handlePasswordInput();
        }

        if (iconType) {
            const newIcon = iconType.endsWith("off") ? iconType.replace("_off", "") : iconType.concat("_off");
            setIconType(newIcon);
        }
    };

    const handlePasswordInput = () => {
        const _inputType = inputType === props.type ? "input" : props.type;
        setInputType(_inputType);
    };

    return (
        <div className={styles.row}>
            <div className={styles.label}>{props.label && props.label}</div>
            <div id={props.name} className={styles.value}>
                <div className={styles.input}>
                    <input name={props.name} type={inputType} value={userName} placeholder={props.placeholder} onChange={handleInputChange} />
                    {iconType && (
                        <div className={styles.icon} onClick={handleIconClick}>
                            <Icon name={iconType} color="lightGrey" />
                        </div>
                    )}
                </div>

                {props.button && <Button label={props.button} size="small" onClick={handleButtonClick} />}
                <span id={`caution_${props.name}`} className={`${styles.desc} ${styles.caution}`}>
                    {props.cautionMsg ? props.cautionMsg : ""}
                </span>
            </div>
        </div>
    );
};

export default UserInfoInput;
